import {IReportPresenter} from "./IReportPresenter";

export class StubReportPresenter implements IReportPresenter {
    showReportById(id: string, requestEdit: boolean) {
    }

    showReport(report: any, extraProps?: ExtraProps) {
    }
}
